import React from "react";

// Counter component (+/- number inputs)
const Counter = (props) => {
    const {valueKey, valueObject, setValue, inputLimit = null} = props;

    const decrement = () => {
        if (valueObject[valueKey] > 0) {
            setValue(valueObject => ({...valueObject, [valueKey]: valueObject[valueKey] - 1}));
        }
    }

    const increment = () => {
        if (!inputLimit || valueObject[valueKey] < inputLimit) {
            setValue(valueObject => ({...valueObject, [valueKey]: valueObject[valueKey] + 1}));
        }
    }

    return (
        <div className="counter">
            <button
                className="counter__button counter__button--decrement"
                disabled={valueObject[valueKey] == 0}
                onClick={() => decrement()}
            >
                -
            </button>
            <input
                className="counter__amount"
                type="number"
                value={valueObject[valueKey]}
                min="0"
                max={inputLimit}
            />
            <button
                className="counter__button counter__button--increment"
                onClick={() => increment()}
                disabled={valueObject[valueKey] == inputLimit}
            >
                +
            </button>
        </div>
    );
}

export default Counter;